import ss from './Session';
import axios from './Axios'

const randomString = (length: number) =>
  new Array(length).fill(0)
    .map((x) => String.fromCharCode(65 + Math.floor(Math.random() * 2) * 32 + Math.floor(Math.random() * 26)))
    .join("");

const getUtmParams = () => {
    const params = new URLSearchParams(window.location.search);
    return Object.fromEntries(
        Object.entries(params)
            .filter(([key]) => key.startsWith('utm_') || key.endsWith('id'))
            .map(([key, value]) => ([key.replace('utm_', ''), value]))
    )
}

// eslint-disable-next-line no-template-curly-in-string
const package_version:string = (((window as any)?.package_version || "NA") === '${package_version}')?"DEV":((window as any)?.package_version || "NA");
const platform = "web";
// SPA: keep sessionid in memory for the duration of the session
let sessionid: string|null = null;
let sessionNumber: number = 0;
    
export async function logBehavior (what: string, detail?: any) {
    if (!detail){
        detail = {}
    }

    if (!detail.page){
        detail.page = window.location.pathname;
    }
    let currentTime = Date.now()/1000;

    if (sessionNumber === 0) {
        try {
            sessionNumber = Number(localStorage.getItem('session:number') || "0") || 0;
        } catch {
            sessionNumber = 0;
        }
    }
        
    if (!sessionid){
        sessionid = randomString(16);
        if (sessionNumber === 0){
            localStorage.setItem('session:firstStartedAt', String(currentTime));
        }
        sessionNumber += 1;

        await sendBehavior("sessionStart", { utm: getUtmParams() });

        localStorage.setItem('session:lastStartedAt', String(currentTime));
        localStorage.setItem('session:number', String(sessionNumber));
    } else {
        await sendBehavior("revisit", {
            interval: currentTime - Number(localStorage.getItem('session:lastStartedAt') || '0'),
            intervalFromStart: currentTime - Number(localStorage.getItem('session:firstStartedAt') || '0'),
            sessionNumber
        });
    }

    return await sendBehavior(what, detail);
}

async function sendBehavior (what: string, detail: any) {
    if (!detail.page){
        if ('canonicalPath' in window){
            detail.page = (window as any).canonicalPath;
        }else{
            detail.page = window.location.pathname;
        }
    }
    
    if (['127.0.0.1', 'localhost:3000', 'koreanmate.app:3000', 'localhost:3001', 'koreanmate.app:3001',
        'dev.koreanmate.app', 'stage.koreanmate.app'
    ].includes(window.location.host)){
        detail.debug = true;
    }
    
    let userid = ss.getCurrentSession().userid;
    try{
        let res = await axios.post('/behavior', {logs:[ {what, userid, sessionid, detail, package_version, platform} ]}, {
            headers: {
                Authorization: `Bearer ${ss.getCurrentSession().jwt}`
            },
            withCredentials: true
        });

        // Add your analytics tracking service here if needed
        // Example: await analytics.logEvent(what, {userid, sessionid, detail});

        if (res.data && res.data.code === 200){
            return true;
        }else{
            return false;
        }
    }catch(e){
        return false;
    }
}

export async function logBulkBehavior (arr: {sessionid: string, userid: string, what: string, detail: any}[]) {
    let userid = ss.getCurrentSession().userid;

    let logs = arr.map(row => ({
        sessionid,
        userid,
        what: row.what,
        package_version,
        platform,
        detail: {
            page: (window as any).canonicalPath || window.location.pathname,
            ...(row.detail),
            ...((['127.0.0.1', 'localhost:3000', 'koreanmate.app:3000', 'localhost:3001', 'koreanmate.app:3001',
                    'dev.koreanmate.app', 'stage.koreanmate.app'
                    ].includes(window.location.host))
                ?{debug: true}:{})
        },
    }))
    try{
        let res = await axios.post('/behavior', {logs}, {
            headers: {
                Authorization: `Bearer ${ss.getCurrentSession().jwt}`
            },
            withCredentials: true
        });

        if (res.data && res.data.code === 200){
            return true;
        }else{
            return false;
        }
    }catch(e){
        return false;
    }
}